import React from 'react';

export const InputField = ({ name, label, placeholder, type = 'text', register, className, errors }) => (
  <label className='flex flex-col space-y-1'>
    <p className='text-xl '>
      {label}
    </p>
    <input
      {...register(name)}
      id={name}
      name={name}
      type={type}
      placeholder={placeholder}
      className={className}
    />
    <p className='font-light text-red-500 text-sm text-center mt-1'>{errors[name]?.message}</p>
  </label>
);

export const TextAreaField = ({ name, label, placeholder, rows, register, className, errors }) => (
  <label className='flex flex-col space-y-1'>
    <p className='text-xl '>
      {label}
    </p>
    <textarea
      {...register(name)}
      name={name}
      placeholder={placeholder}
      className={className}
      rows={rows}
    />
    <p className='font-light text-red-500 text-sm text-center mt-1'>{errors[name]?.message}</p>
  </label>
);

export const encode = data => {
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    formData.append(key, data[key]);
  });
  return formData;
};

export const urlEncode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};
